// extracted by mini-css-extract-plugin
export default {"button":"back_button__dSiIM","back":"back_back__MUKan"};